export const LS_KEY_VERSION = "xllab-interior-ai-v2";
export const LS_KEY_LANGSET = "xllab-has-preferred-lang";
export const LS_KEY_DISPLAY_FEEDBACK_WINDOW_ON_PAY = "display-feedback-first-pay";
export const LS_KEY_THEME_TOUR = "interior-ai-theme-tour";
export const LS_KEY_STARTUP_GUIDE_INSPIRE = "interior-ai-inspire-guide";
export const LS_KEY_STARTUP_GUIDE_PREDICTOR = "interior-ai-predictor-guide";